import {
  syncFormPropertyStepInputData,
  syncIncidentTypePropertyStepInputData,
} from 'utils/flowBlockInput';

// TODO: Future: consider other places to put this so that it's not manually invoked so often
// Potentially a selector? It would be a big refactor though to use the selectors value everywhere
// instead of reducer inputs...
export default function syncDynamicBlockInputs(stateToUpdate) {
  const {
    planLayoutByFormId,
    isIncidentManagementEnabled,
    planCanvas,
    incidentTypes,
    customSteps,
  } = stateToUpdate;
  const existingInputs = stateToUpdate.inputs ?? planCanvas?.inputs;

  if (!planCanvas || !existingInputs || !planCanvas.blocks) {
    return stateToUpdate;
  }

  const shouldSyncFormLayout = !!planLayoutByFormId;
  const shouldSyncIncidentTypeProperties =
    !!incidentTypes?.length && isIncidentManagementEnabled;

  if (!shouldSyncFormLayout && !shouldSyncIncidentTypeProperties) {
    return stateToUpdate;
  }

  let inputs = [...existingInputs];
  if (shouldSyncFormLayout) {
    inputs = syncFormPropertyStepInputData({
      inputs,
      blocks: planCanvas?.blocks,
      planLayoutByFormId,
      isIncidentManagementEnabled,
    });
  }

  if (shouldSyncIncidentTypeProperties) {
    inputs = syncIncidentTypePropertyStepInputData({
      inputs,
      blocks: planCanvas?.blocks,
      incidentTypes,
      customSteps,
    });
  }

  return {
    ...stateToUpdate,
    planCanvas: {
      ...planCanvas,
      inputs,
    },
    inputs,
  };
}
